import { Outlet } from "react-router";
import CommonHero from "../layout/common/commonHero";
import Navbar from "../layout/homePage/navbar/navbar";
import HomePageFooter from "../layout/homePage/footer/HomePageFooter";
import BikeRentGrid from "../layout/bike-rent/BikeRentGrid";

export default function BikeRent() {
  return (
   <>
    <Navbar />
    <CommonHero />
    <Outlet />
    <BikeRentGrid />
    <HomePageFooter />
   </>
  );
}